import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const LOGO_COLORED_URL = 'https://storage.readdy-site.link/project_files/9a159650-d207-4927-ac66-460895b17acb/6eca2e1e-9c1c-4705-bea3-06ae02cb41bd_logo-azul.png?v=095133d4e4ff9eb65867ca40185a709b';
const LOGO_WHITE_URL = 'https://storage.readdy-site.link/project_files/9a159650-d207-4927-ac66-460895b17acb/39f67378-3e18-4b3c-b5fd-ca850bf4a203_logo-branco.png?v=f83db6c6c980c4807f6a1735dc9ba965';

const navLinks = [
  { label: 'Início', path: '/' },
  { label: 'Jornada de Avaliação', path: '/jornada' },
  { label: 'Pré-Anamnese', path: '/pre-anamnese' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-0 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img
            src={scrolled ? LOGO_COLORED_URL : LOGO_WHITE_URL}
            alt="Logo Neuro Elos"
            className="h-[64px] w-auto object-contain transition-opacity duration-300"
          />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`relative font-sans text-sm font-700 tracking-wide transition-all duration-200 whitespace-nowrap cursor-pointer pb-1 ${
                location.pathname === link.path
                  ? 'text-coral border-b-2 border-coral'
                  : scrolled
                  ? 'text-navy hover:text-coral border-b-2 border-transparent hover:border-coral/40'
                  : 'text-white/90 hover:text-white border-b-2 border-transparent hover:border-white/50'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <a
          href="https://wa.me/5511981882825"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:inline-flex items-center gap-2 bg-coral text-white px-5 py-2.5 rounded-full text-sm font-600 font-sans whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-coral-dark"
        >
          <i className="ri-whatsapp-line text-base" />
          Agendar Avaliação
        </a>

        <button
          className="md:hidden cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-navy' : 'text-white'}`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white shadow-lg px-6 pb-6 pt-2">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block py-3 font-sans text-sm font-700 tracking-wide border-b border-beige-dark last:border-0 cursor-pointer transition-colors duration-200 ${
                location.pathname === link.path ? 'text-coral' : 'text-navy hover:text-coral'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://wa.me/5511981882825"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 block text-center bg-coral text-white px-5 py-3 rounded-full text-sm font-600 font-sans cursor-pointer"
          >
            Agendar Avaliação
          </a>
        </div>
      )}
    </nav>
  );
}
